// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"e91430bb","239":"fde5349e","389":"247d3cc4","455":"e6105e23","977":"e78cee3e"}[chunkId] + ".chunk.js";
};